import {
  TAB_JOBDETAIL,
  TAB_PR,
  TAB_RV,
  TAB_SEMINAR,
  TAB_PHOTOS,
} from '@doda/common/src/constants/properties/const';

export const TAB_STATE = {
  requirement: 'requirement',
  applicationMethod: 'applicationMethod',
  pr: 'pr',
  seminar: 'seminar',
  review: 'review',
  jobdetail: 'jobdetail', // PC求人詳細タブ
  photos: 'photos',
  photos_pc: 'photos_pc', // PC写真タブ
} as const;

export type TabState = keyof typeof TAB_STATE;

export const TAB_STATE_TO_PATH = {
  requirement: TAB_JOBDETAIL,
  applicationMethod: TAB_JOBDETAIL,
  pr: TAB_PR,
  seminar: TAB_SEMINAR,
  review: TAB_RV,
  jobdetail: TAB_JOBDETAIL,
  photos: TAB_PHOTOS,
} as const;
